import { Injectable } from '@angular/core';

import { TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { ButtonClickEventData } from './model/update-mobile-number.model';

@Injectable()
export class UpdateMobileNumberTrackingService {
    constructor(private trackingService: TrackingService) {}

    trackPopupShown(): void {
        const trackingData: TrackData = {
            ...this.getBaseTrackingData(),
            [trackingConstants.COMPONENT_ACTION_EVENT]: TrackingValues.Load,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: TrackingValues.Details,
            [trackingConstants.COMPONENT_URL_CLICKED]: TrackingValues.NotApplicable,
        };
        this.trackingService.track(trackingConstants.EVENT_CONTENT_VIEW, trackingData);
    }

    trackButtonClick(eventData: ButtonClickEventData): void {
        const trackingData: TrackData = {
            ...this.getBaseTrackingData(),
            [trackingConstants.COMPONENT_ACTION_EVENT]: TrackingValues.Click,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: eventData.details,
            [trackingConstants.COMPONENT_URL_CLICKED]: eventData.url || TrackingValues.NotApplicable,
        };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    getBaseTrackingData(): TrackData {
        return {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: TrackingValues.Mfa,
            [trackingConstants.COMPONENT_LABEL_EVENT]: TrackingValues.MfaSetup,
            [trackingConstants.COMPONENT_POSITION_EVENT]: TrackingValues.Na,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: TrackingValues.Details,
        };
    }
}

export enum TrackingValues {
    Mfa = 'mfa',
    MfaSetup = 'mfa setup',
    Click = 'click',
    Load = 'load',
    Na = 'na',
    Details = 'mobile number verification popup',
    Confirm = 'confirm',
    UpdateMobileNumber = 'update mobile number',
    NotApplicable = 'not applicable',
    Update = 'update',
}
